module.exports = __webpack_public_path__ + "img/battery-charging-icon.487f9f8d.svg";